import { useQuery } from '@tanstack/react-query';

type RemoteDocsConnection = {
  id: string;
  status: 'ACTIVE' | 'REVOKED' | 'PENDING';
  createdAt: string;
};

export const useRemoteDocsConnections = () => {
  const { data, isLoading, isError } = useQuery<RemoteDocsConnection[]>({
    queryKey: ['remote-docs-connections'],
  });

  const getLatestActiveConnection = () => {
    if (data) {
      const activeConnections = data.filter(connection => connection.status === 'ACTIVE');
      activeConnections.sort(
        (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      );
      return activeConnections[0] || null;
    }
    return null;
  };

  return {
    connections: data,
    latestActiveConnection: getLatestActiveConnection(),
    isLoading,
    isError,
  };
};
